/**
 * @file 차계부(법인차량 운행일지) API
 * 차량 카탈로그(사진 포함) + 월별 운행일지 CRUD.
 */
import { api } from "../../../util/api";

const API_BASE = process.env.REACT_APP_API_BASE_URL;
const V = `${API_BASE}/vehicles`;
const L = `${API_BASE}/vehicle-logs`;

export const vehicleApi = {
    // ─── 차량 (카드) ─────────────────────────────────────────────
    /** 차량 목록 — 누적 KM·기록 수 포함 */
    getVehicles: (includeInactive = false) => api.get(V, { includeInactive }),
    getVehicle:  (id)        => api.get(`${V}/${id}`),
    createVehicle: (data)    => api.post(V, data),
    updateVehicle: (id, data) => api.put(`${V}/${id}`, data),
    deleteVehicle: (id)      => api.delete(`${V}/${id}`),

    /** 차량 사진 업로드 (이미지 파일) */
    uploadVehicleImage: (id, file) => {
        const fd = new FormData();
        fd.append("file", file);
        return api.upload(`${V}/${id}/image`, fd);
    },
    deleteVehicleImage: (id) => api.delete(`${V}/${id}/image`),

    // ─── 운행일지 ────────────────────────────────────────────────
    /** 월별 운행일지 + 요약. vehicleId 를 비우면 전 차량 통합. */
    getMonthlyLogs: (vehicleId, year, month) =>
        api.get(L, { ...(vehicleId ? { vehicleId } : {}), year, month }),
    /** 운행 목적 코드 목록 (드롭다운) */
    getPurposes: () => api.get(`${L}/purposes`),
    /** 직전 계기판 — 새 기록의 '주행 전' 기본값 */
    getLastLog: (vehicleId) => api.get(`${L}/last`, { vehicleId }),

    createLog: (data)     => api.post(L, data),
    updateLog: (id, data) => api.put(`${L}/${id}`, data),
    deleteLog: (id)       => api.delete(`${L}/${id}`),

    // ─── 참조 데이터 ─────────────────────────────────────────────
    /** 로그인 사용자 — 운행자 기본값(본인)으로 쓴다. */
    getMe: () => api.get(`${API_BASE}/employees/me`),
};
